// extracted by mini-css-extract-plugin
module.exports = {"signUp":"sign-up_signUp__xU10b","signUpElement":"sign-up_signUpElement__YLIrA","consentContainer":"sign-up_consentContainer__Gsdp1"};